import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./EditUom.css";
import {
  getUomById,
  updateUomApi,
} from "../../../../services/UOM/uom.service";

const EditUom: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("active");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUom = async () => {
      if (!id) return;
      const data = await getUomById(Number(id));
      setName(data.name);
      setDescription(data.description);
      setStatus(data.status);
      setLoading(false);
    };
    fetchUom();
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;

    await updateUomApi(Number(id), {
      name,
      description,
      status,
    });

    navigate("/uom/list");
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="add-category-container">
      <h2>Edit UOM</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="UOM Name"
        />

        <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description"
        />
        <div className="button-close">
        <button type="button" onClick={() => navigate("/category/list")}>close</button>
        <button type="submit">Update UOM</button>
        </div>
      </form>
    </div>
  );
};

export default EditUom;
